import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderEn = () => {
    return (
        <HighlightedText
            text="CLAIM YOUR BONUS"
            highlights={[{ word: 'YOUR' }, { word: 'BONUS' }]}
            className={common.text_header}
        />
    )
}

export const TextLandEn = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 FREESPINS"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Bonus']}
            className={styles.text_content}
        />
    )
}
